
export function getHasPermission(me, route) {
  const hasPermission =
    me?.role === "VENDOR" ||
    (me?.role === "CUSTOM" && me?.permissions.includes(route.permission)) ||
    route.roles?.includes("all");

  return hasPermission;
}
